import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './GameDetailPage.css';
import cricketWomanImage from "../assets/cricketWomanImage.png"
const GameDetailPage = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();

  // Game data - you can expand this with more games
  const gamesData = {
    'badminton': {
      title: 'Badminton',
      image: 'https://badmintonhq.co.uk/cdn/shop/articles/123.jpg?v=1704207657',
      description: 'Professional badminton training with certified coaches and world-class facilities, designed to enhance skills, speed, and on-court performance.',
      fullDescription: 'Our badminton training program provides a complete and structured learning experience for players of every level. Beginners receive step-by-step guidance on footwork, grip, strokes, and basic positioning, while intermediate players work on improving speed, timing, agility, and shot accuracy. Advanced athletes are trained in match strategies, power play, deceptive shots, and high-performance techniques used by professional players. With certified coaches, personalized training plans, modern facilities, and regular performance assessments, we ensure every player continuously improves and reaches their maximum potential on the court.',      features: [
        'Professional coaching from certified instructors',
        'State-of-the-art badminton courts',
        'Equipment provided for beginners',
        'Tournament preparation and strategy',
        'Fitness and conditioning programs',
        'Group and individual training sessions'
      ],
      schedule: 'Monday - Friday: 6:00 AM - 9:00 PM, Saturday - Sunday: 7:00 AM - 8:00 PM',
      pricing: 'Starting from ₹2,000/month',
      coach: 'Piyush Parihar - Certified Badminton Coach'
    },
    'sportsMeditation': {
      title: 'Sports Meditaion',
      image: 'https://askmesportsalliance.com/static/media/meditationImage.261162b4a51e790c9a70.jpeg',
      description: 'Professional sports meditation sessions to enhance focus, calmness, and performance.',

      fullDescription: 'Our sports meditation program is designed to help athletes improve mental clarity, emotional balance, and overall performance. Whether you are a beginner or a professional player, these guided sessions help reduce stress, boost concentration, and build a stronger mind–body connection essential for peak athletic performance.',

      features: [
        'Guided meditation by trained experts',
        'Focus-building and stress-reduction techniques',
        'Breathing exercises for better control',
        'Mind–body awareness enhancement',
        'Performance-focused mental conditioning',
        'Suitable for all age groups and skill levels'
      ],
      schedule: 'Monday - Friday: 6:00 AM - 9:00 PM, Saturday - Sunday: 7:00 AM - 8:00 PM',
      pricing: 'Starting from ₹2,000/month',
      coach: 'Praachal - Spors Meditation Expert'
    },
    'sportsPsychologits': {
      title: 'Sports Psychologits',
      image: 'https://www.thehawk.in/_next/image?url=https%3A%2F%2Fd2py10ayqu2jji.cloudfront.net%2FSports%2520Psychologist.webp&w=3840&q=75',
      description: 'Professional sports psychology sessions to improve mindset, confidence, and performance.',
      fullDescription: 'Our sports psychology program helps athletes build a strong mental foundation to enhance performance under pressure. Through personalized sessions, athletes learn to manage stress, boost confidence, overcome performance anxiety, and develop a winning mindset. These scientifically backed techniques support athletes at every level to stay focused, motivated, and mentally resilient.',
      features: [
        'One-on-one sessions with certified sports psychologists',
        'Performance anxiety and stress management',
        'Confidence-building and motivation techniques',
        'Goal-setting and mental clarity development',
        'Emotional regulation and focus enhancement',
        'Support for athletes of all levels and age groups'
      ],
      schedule: 'Monday - Friday: 6:00 AM - 9:00 PM, Saturday - Sunday: 7:00 AM - 8:00 PM',
      pricing: 'Starting from ₹2,000/month',
      coach: 'Chitra - Spors Psychologits '
    },
    'sportsFitness': {
      title: 'Sports Fitness',
      image: 'https://img.freepik.com/free-photo/tanned-young-athletic-girl-doing-abs-workout-yoga-mat_651396-1725.jpg?semt=ais_incoming&w=740&q=80',
      description: 'Professional sports psychology sessions to improve mindset, confidence, and performance.',
      description: 'Professional sports fitness training to boost strength, agility, stamina, and overall performance.',
      fullDescription: 'Our sports fitness program is designed to help athletes build a strong, agile, and high-performing body. With structured workout routines, strength building, flexibility training, and endurance development, this program ensures complete physical conditioning. Whether you are a beginner or an advanced athlete, our expert trainers guide you with personalized fitness plans that enhance your performance and prevent injuries.',
      features: [
        'Strength and conditioning programs',
        'Agility, flexibility, and mobility training',
        'Endurance and stamina-building workouts',
        'Sport-specific fitness routines',
        'Injury-prevention and recovery exercises',
        'Suitable for athletes of all ages and skill levels'
      ],
      schedule: 'Monday - Friday: 6:00 AM - 9:00 PM, Saturday - Sunday: 7:00 AM - 8:00 PM',
      pricing: 'Starting from ₹2,000/month',
      coach: 'Chitra Ceo Director - Spors Psychologits '
    },
    'table-tennis': {
      title: 'Table Tennis',
      image: "https://the.ismaili/Images/Smashing_Limits_The_Making_of_a_Table_Tennis_Champion_53662.png",
      description: 'Expert table tennis coaching and training programs for all skill levels.',
      fullDescription: 'Master the art of table tennis with our comprehensive training program. Our experienced coaches focus on technique, strategy, and mental preparation to help you excel in this fast-paced sport.',
      features: [
        'Professional table tennis coaching',
        'Modern equipment and facilities',
        'Tournament preparation',
        'Mental training and focus techniques',
        'Physical conditioning specific to table tennis',
        'Video analysis of your gameplay'
      ],
      schedule: 'Monday - Friday: 5:00 AM - 10:00 PM, Saturday - Sunday: 6:00 AM - 9:00 PM',
      pricing: 'Starting from ₹1,800/month',
      coach: 'Mohit Verma - Professional Table Tennis Coach'
    },
    'tennis': {
      title: 'Tennis',
      image: "https://thumbs.dreamstime.com/b/back-view-shot-indian-senior-man-busy-playing-tennis-hitting-ball-racquet-court-concept-mistakes-practising-280198852.jpg",
      description: 'Professional tennis training and development programs with experienced coaches.',
      fullDescription: 'Develop your tennis skills with our comprehensive training program. From basic strokes to advanced techniques, our professional coaches will guide you through every aspect of the game.',
      features: [
        'Professional tennis coaching',
        'Multiple court surfaces available',
        'Tournament preparation and strategy',
        'Fitness and conditioning programs',
        'Video analysis and technique improvement',
        'Mental training and match preparation'
      ],
      schedule: 'Monday - Friday: 5:30 AM - 9:30 PM, Saturday - Sunday: 6:30 AM - 8:30 PM',
      pricing: 'Starting from ₹3,000/month',
      coach: 'Riyaz Ahmed - Certified Tennis Professional'
    },
    'athletics': {
      title: 'Athletics',
      image: "https://glorymedalhangers.com/cdn/shop/articles/eikm0smecpelgljn5l2k.jpg?v=1653297054&width=3200",
      description: 'Track and field training with specialized coaching and modern facilities.',
      fullDescription: 'Excel in track and field events with our specialized athletics program. Our coaches work with athletes across all disciplines to improve performance and achieve personal bests.',
      features: [
        'Specialized coaching for all track and field events',
        'Modern training facilities and equipment',
        'Performance analysis and improvement',
        'Competition preparation',
        'Strength and conditioning programs',
        'Nutrition and recovery guidance'
      ],
      schedule: 'Monday - Friday: 5:00 AM - 8:00 PM, Saturday - Sunday: 6:00 AM - 7:00 PM',
      pricing: 'Starting from ₹2,500/month',
      coach: 'Hitesh Deshwal - Athletics Specialist'
    },
    'boxing': {
      title: 'Boxing',
      image: "https://images.unsplash.com/photo-1564097147829-44f8c74a8549?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Ym94aW5nJTIwaW5kaWFucyd8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=400",
      description: 'Professional boxing training and fitness programs with expert trainers.',
      fullDescription: 'Train like a champion with our professional boxing program. Whether you\'re looking to compete or just get in shape, our expert trainers will guide you through proper technique and conditioning.',
      features: [
        'Professional boxing coaching',
        'Heavy bag and speed bag training',
        'Sparring sessions (for advanced students)',
        'Fitness and conditioning programs',
        'Self-defense techniques',
        'Mental toughness training'
      ],
      schedule: 'Monday - Friday: 6:00 AM - 9:00 PM, Saturday - Sunday: 7:00 AM - 8:00 PM',
      pricing: 'Starting from ₹2,200/month',
      coach: 'Akshay Kalosia - Professional Boxing Trainer'
    },
    'weightlifting': {
      title: 'Weightlifting',
      image: "https://images.unsplash.com/photo-1646495001290-39103b31873a?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8d2VpZ2h0bGlmdGluZyUyMGluZGlhfGVufDB8fDB8fHww&auto=format&fit=crop&q=60&w=400",
      description: 'Strength training and weightlifting coaching for all levels.',
      fullDescription: 'Build strength and power with our comprehensive weightlifting program. Our certified trainers will teach you proper form and technique while helping you achieve your strength goals.',
      features: [
        'Certified weightlifting coaching',
        'Modern equipment and facilities',
        'Personalized training programs',
        'Technique and form correction',
        'Competition preparation',
        'Injury prevention and recovery'
      ],
      schedule: 'Monday - Friday: 5:00 AM - 10:00 PM, Saturday - Sunday: 6:00 AM - 9:00 PM',
      pricing: 'Starting from ₹1,500/month',
      coach: 'Monika - Certified Weightlifting Coach'
    },
    'powerlifting': {
      title: 'Powerlifting',
      image: "https://thebridge.in/h-upload/2023/12/08/51626-ashok.webp",
      description: 'Powerlifting training and competition preparation with certified coaches.',
      fullDescription: 'Master the three powerlifting movements with our specialized program. Our certified coaches will help you improve your squat, bench press, and deadlift while preparing for competitions.',
      features: [
        'Specialized powerlifting coaching',
        'Competition preparation',
        'Technique refinement for the big three',
        'Strength periodization programs',
        'Equipment and gear guidance',
        'Mental preparation for competitions'
      ],
      schedule: 'Monday - Friday: 5:00 AM - 10:00 PM, Saturday - Sunday: 6:00 AM - 9:00 PM',
      pricing: 'Starting from ₹2,000/month',
      coach: 'Mala Sukhwal - Certified Powerlifting Coach'
    },
    // 'basketball': {
    //   title: 'Basketball',
    //   image: "https://images.unsplash.com/photo-1505666287802-931dc83948e9?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGJhc2tldGJhbGx8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=400",
    //   description: 'Basketball training and team development programs for all ages.',
    //   fullDescription: 'Develop your basketball skills with our comprehensive training program. From fundamentals to advanced techniques, our coaches will help you improve your game and team play.',
    //   features: [
    //     'Professional basketball coaching',
    //     'Team and individual training',
    //     'Skill development programs',
    //     'Game strategy and tactics',
    //     'Physical conditioning',
    //     'Tournament preparation'
    //   ],
    //   schedule: 'Monday - Friday: 6:00 AM - 9:00 PM, Saturday - Sunday: 7:00 AM - 8:00 PM',
    //   pricing: 'Starting from ₹2,200/month',
    //   coach: 'Sarah - Basketball Coach'
    // },
    'volleyball': {
      title: 'Volleyball',
      image: "https://asianvolleyball.net/new/wp-content/uploads/2019/11/men-india-v-nepal3.jpg",
      description: 'Volleyball coaching and team training programs with professional guidance.',
      fullDescription: 'Master the fundamentals and advanced techniques of volleyball with our comprehensive training program. Our coaches focus on both individual skills and team dynamics.',
      features: [
        'Professional volleyball coaching',
        'Team training and development',
        'Individual skill improvement',
        'Game strategy and tactics',
        'Physical conditioning',
        'Tournament and league preparation'
      ],
      schedule: 'Monday - Friday: 6:00 AM - 9:00 PM, Saturday - Sunday: 7:00 AM - 8:00 PM',
      pricing: 'Starting from ₹2,000/month',
      coach: 'Maria Doe - Volleyball Coach'
    },
    'cricket-women': {
      title: 'Cricket (Women)',
      image: cricketWomanImage,
      description: 'Women\'s cricket training and development programs with expert coaching.',
      fullDescription: 'Join our specialized women\'s cricket program designed to develop skills, confidence, and team spirit. Our expert coaches provide comprehensive training for all aspects of the game.',
      features: [
        'Specialized women\'s cricket coaching',
        'Batting and bowling technique development',
        'Fielding and wicket-keeping training',
        'Fitness and conditioning programs',
        'Mental training and confidence building',
        'Tournament and match preparation'
      ],
      schedule: 'Monday - Friday: 5:30 AM - 8:30 PM, Saturday - Sunday: 6:30 AM - 7:30 PM',
      pricing: 'Starting from ₹2,500/month',
      coach: 'Zahir Taj - Women\'s Cricket Coach'
    },
    'shooting': {
      title: 'Shooting',
      image: "https://images.indianexpress.com/2021/05/indian-shooting.jpg?w=414",
      description: 'Professional shooting training and precision coaching with modern equipment.',
      fullDescription: 'Develop precision and focus with our professional shooting program. Our certified instructors provide comprehensive training in various shooting disciplines with modern equipment.',
      features: [
        'Professional shooting instruction',
        'Modern equipment and facilities',
        'Safety training and protocols',
        'Competition preparation',
        'Mental focus and concentration training',
        'Equipment maintenance and care'
      ],
      schedule: 'Monday - Friday: 6:00 AM - 8:00 PM, Saturday - Sunday: 7:00 AM - 6:00 PM',
      pricing: 'Starting from ₹3,500/month',
      coach: 'Shikha Dhall - Certified Shooting Instructor'
    }
  };

  const game = gamesData[gameId];

  if (!game) {
    return (
      <div className="game-detail-page">
        <div className="container">
          <div className="error-message">
            <h1>Game Not Found</h1>
            <p>The requested game could not be found.</p>
            <button onClick={() => navigate('/')} className="back-btn">
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="game-detail-page">
      <div className="container">
        <button onClick={() => navigate('/')} className="back-btn">
          ← Back to Home
        </button>

        <div className="game-detail-content">
          <div className="game-image-section">
            <img src={game.image} alt={game.title} className="game-detail-image" />
          </div>

          <div className="game-info-section">
            <h1 className="game-detail-title">{game.title}</h1>
            <p className="game-detail-description">{game.fullDescription}</p>

            <div className="game-features">
              <h3>What We Offer:</h3>
              <ul>
                {game.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            <div className="game-details-grid">
              <div className="detail-item">
                <h4>Coach</h4>
                <p>{game.coach}</p>
              </div>
            </div>

            <div className="action-buttons">
              <Link to="/contact" className="enroll-btn">Enroll Now</Link>
              <Link to="/contact" className="contact-btn">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameDetailPage;
